import { message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Form,
    ModalItem,
    ButtonItem,
    ErrorItem,
} from "../../../../Components/Items";
import CamposPerimetroChecada, { valoresAPayload } from "../CamposPerimetroChecada";

class AgregarPerimetroChecada extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
    };
    cerrarAgregarPerimetroChecada(codigo) {
        this.props.cerrarAgregarPerimetroChecada(codigo);
    }
    onFinishFailed(e) {
        ErrorItem(e);
    }
    onFinish(values) {
        this.setState({ loading: true });
        axios
            .post(
                "perimetrosChecada/agregarPerimetroChecada",
                { ...valoresAPayload(values), empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Se ha registrado un perímetro de checada");
                    this.formRef.current.resetFields();
                    this.cerrarAgregarPerimetroChecada();
                } else if (res.data.success === 1) {
                    message.error(res.data.message || "No se puede registrar el perímetro");
                } else {
                    message.error("Hubo un error y el perímetro no se registro");
                }
            });
    }
    render() {
        return (
            <>
                <ModalItem
                    title="Agregar Perímetro de Checada"
                    visible={this.props.visible}
                    spinning={this.state.loading}
                    onCancel={this.cerrarAgregarPerimetroChecada.bind(this)}
                    paddingTop
                >
                    <Form
                        ref={this.formRef}
                        name="agregarPerimetroChecada"
                        layout
                        bottom={
                            <ButtonItem
                                type="primary"
                                htmlType="submit"
                                style={{ display: "block", margin: "0 0 0 auto" }}
                            >
                                Agregar
                            </ButtonItem>
                        }
                        onFinish={this.onFinish.bind(this)}
                        onFinishFailed={this.onFinishFailed}
                    >
                        <CamposPerimetroChecada
                            empresaId={this.props.empresaId}
                            headersToken={this.props.headersToken}
                        />
                    </Form>
                </ModalItem>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(AgregarPerimetroChecada);
